import { apiFetch } from './client';
import type { DebtEntry } from '$lib/types';

export const debtApi = {
  forProject: (projectId: number) => apiFetch<{ results: DebtEntry[]; count: number }>(`/projects/${projectId}/debt`),
  create: (projectId: number, body: { desc: string; severity?: string; ceiling?: string }) =>
    apiFetch<DebtEntry>(`/projects/${projectId}/debt`, { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: Partial<{ desc: string; severity: string; ceiling: string; resolved: boolean }>) =>
    apiFetch<DebtEntry>(`/debt/${id}`, { method: 'PATCH', body: JSON.stringify(body) })
};
